'use strict';

const legalDocStates = ({ elm }) => {
	return [
		elm({
			name: 'LatestLegalDoc',
			moduleName: 'LatestLegal.Main',
			url: '/public/legal/:type',
			pageTitle: 'user_settings.navigation.legal_documents',
			argsResolver: [
				'$stateParams',
				$stateParams => {
					let routeParamNames = Object.getOwnPropertyNames($stateParams).filter(x => x !== '#');
					let stateParams = routeParamNames.reduce(function (obj, p) {
						obj[p] = $stateParams[p];
						return obj;
					}, {});
					return stateParams;
				}
			]
		}),
		elm({
			name: 'LatestDocId',
			moduleName: 'LatestLegal.Main',
			url: '/public/legal/:type/:id',
			pageTitle: 'user_settings.navigation.legal_documents',
			argsResolver: [
				'$stateParams',
				$stateParams => {
					let routeParamNames = Object.getOwnPropertyNames($stateParams).filter(x => x !== '#');
					let stateParams = routeParamNames.reduce(function (obj, p) {
						obj[p] = $stateParams[p];
						return obj;
					}, {});
					return stateParams;
				}
			]
		})
	];
};

module.exports = {
	legalDocStates
};
